<pr-notifications
  [notifications]="notifications$ | ngrxPush"
 />
